import { useAuthenticatedApi } from '@/hooks/useAuthenticatedApi';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2, Wifi, WifiOff } from 'lucide-react';

export const AuthenticationStatus = () => {
  const { isAuthenticated } = useAuthenticatedApi();

  if (isAuthenticated) {
    return (
      <Alert className="mb-4 border-green-500/20 bg-green-50 dark:bg-green-950/20">
        <Wifi className="h-4 w-4 text-green-600" />
        <AlertDescription className="text-green-700 dark:text-green-300">
          Authenticated - Your progress will be saved automatically
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert className="mb-4 border-amber-500/20 bg-amber-50 dark:bg-amber-950/20">
      <WifiOff className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-amber-700 dark:text-amber-300">
        Web mode - Progress will be saved locally with IP restrictions
      </AlertDescription>
    </Alert>
  );
};